import React, { forwardRef } from "react";
import useMediaQuery from "../../hooks/useMediaQuery";

import COLORS from "../../constants/colors";

import Typography from "../Typography";
import Button from "../Button";
import Flex from "../../layout/Flex";
import { FileUploader } from "react-drag-drop-files";

import { FileInputProps } from "./FileInput.types";
import { FileInputPreviewer, FileInputWrapper } from "./FileInput.styles";

const defaultFileTypes = ["JPG", "PNG", "JPEG"];

const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
    (props: FileInputProps, ref) => {
        const {
            selectedFile,
            fileTypes = defaultFileTypes,
            onChange,
            name = "file",
            hoverTitle,
            id = "",
            label = "Drop file here to start uploading",
            ctaText = "Upload",
            maxSize,
            minSize,
            multiple,
            onDrop,
            onSelect,
            disabled,
            onSizeError,
            onTypeError,
            onClick,
        } = props;

        const isMobileScreen = useMediaQuery({ queryType: "mobile" });

        const handleChange = (f: File) => {
            onChange(f);
        };

        return (
            <FileInputWrapper>
                <FileUploader
                    handleChange={handleChange}
                    name={name}
                    multiple={multiple}
                    types={fileTypes}
                    label={label}
                    disabled={disabled}
                    maxSize={maxSize}
                    minSize={minSize}
                    onDrop={onDrop}
                    onSelect={onSelect}
                    hoverTitle={hoverTitle}
                    ref={ref}
                    onSizeError={onSizeError}
                    onTypeError={onTypeError}
                >
                    <Flex
                        flexDirection="column"
                        gap={20}
                        alignItems="center"
                        padding={30}
                    >
                        {selectedFile ? (
                            <FileInputPreviewer
                                src={(URL as any).createObjectURL(selectedFile)}
                                alt={name}
                            />
                        ) : (
                            <>
                                {!isMobileScreen && label ? (
                                    <>
                                        <Typography weight="medium" size="l">
                                            {label}
                                        </Typography>
                                        <Typography weight="medium">
                                            OR
                                        </Typography>
                                    </>
                                ) : null}

                                <Button
                                    fillType="outlined"
                                    id={id}
                                    onClick={onClick}
                                >
                                    {ctaText}
                                </Button>

                                {maxSize ? (
                                    <Flex
                                        alignItems="center"
                                        justifyContent="center"
                                        gap={5}
                                    >
                                        <Typography color={COLORS.RED} size="s">
                                            *
                                        </Typography>
                                        <Typography size="s" weight="medium">
                                            Max size {maxSize} MB
                                        </Typography>
                                    </Flex>
                                ) : null}
                            </>
                        )}
                    </Flex>
                </FileUploader>
            </FileInputWrapper>
        );
    },
);

export default FileInput;
